import { createFileRoute, useLoaderData } from "@tanstack/react-router";
import { ContentRenderer } from "~/components/ContentRenderer";
import { getCmsPageContent } from "~/lib/server-functions/get-cms-page-content";
import { getBaseUrl, resolveAssetUrlServer } from "~/lib/utils";
import { withLocale } from "~/lib/utils/with-locale";
import { seo } from "~/utils/seo";

function findFirstHeroImage(content: any[]): string | undefined {
  for (const item of content) {
    if (item.type === "locationguide_hero" && item.data?.locations?.length) {
      const firstLocation = item.data.locations[0];
      const ogImage =
        firstLocation?.images?.find(
          (img: any) =>
            img.mimetype &&
            !img.mimetype.startsWith("video") &&
            img.purpose === "location_gallery_image",
        ) ?? firstLocation?.images?.[0];
      if (ogImage?.path) {
        return resolveAssetUrlServer(ogImage.path);
      }
      return undefined;
    }
    if (item.children?.length) {
      const found = findFirstHeroImage(item.children);
      if (found) return found;
    }
  }
  return undefined;
}

export const Route = createFileRoute("/__main/$locale/")({
  component: Home,
  loader: async () => {
    return await getCmsPageContent({ data: { slug: "/" } });
  },
  head: ({ loaderData }) => {
    const image = loaderData?.content
      ? findFirstHeroImage(loaderData.content)
      : undefined;
    const cmsTitle = loaderData?.pageTitle?.trim() || "";
    const title = cmsTitle
      ? `${cmsTitle} | Locationguide24`
      : "Locationguide24";
    const canonicalUrl = `${getBaseUrl()}${withLocale("/")}`;
    return {
      meta: [
        ...seo({
          title,
          description: `Locationguide24 ► Eventlocation, Hochzeitslocation, Tagungsraum, Tagungshotel in München, Berlin, Hamburg, Wien, Köln, Frankfurt, Stuttgart, Düsseldorf`,
          url: canonicalUrl,
          siteName: "Locationguide24",
          locale: "de_DE",
          image,
        }),
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
});

function Home() {
  const { content } = useLoaderData({ from: "/__main/$locale/" });

  return (
    <>
      {content.map((item: any) => (
        <ContentRenderer key={item.uid} item={item} />
      ))}
    </>
  );
}
